module.exports = {
    app: {
        apiUrl: process.env.REACT_APP_BASE_URL
    },
    PK_MAGIC_LINK: process.env.REACT_APP_PK_MAGIC_LINK,
    SECRET_KEY: process.env.REACT_APP_SECRET_KEY,
    GOOGLE_CLIENTID: process.env.REACT_APP_GOOGLE_CLIENTID,
    MAGIC_REDIRECT_URI: process.env.REACT_APP_MAGIC_REDIRECT_URI,
    ZENDESK_SUPPORT: `https://${process.env.REACT_APP_ZENDESK_SUPPORT}`,
    KYC_WHY: `https://${process.env.REACT_APP_KYC_WHY}`,
    S3_GYL_ICONS: `https://${process.env.REACT_APP_S3_GYL_ICONS}`,
    WALLET_GUIDE: `https://${process.env.REACT_APP_WALLET_GUIDE}`,
    SUPPORT_EMAIL: process.env.REACT_APP_SUPPORT_EMAIL,
    PRIVACY_POLICY: `https://${process.env.REACT_APP_PRIVACY_POLICY}`,
    TERMS_CONDITION: `https://${process.env.REACT_APP_TERMS_CONDITION}`,
    HOWTOCREATEWALLET: `https://${process.env.REACT_APP_HOWTOCREATEWALLET}`,
    ONBOARDING_GUIDE_LINK: `https://${process.env.REACT_APP_ONBOARDING_GUIDE}`,
    ABOUT_LINK: `https://${process.env.REACT_APP_ABOUT_LINK}`,
    MIN_WITHDRAWL_AMOUNT: process.env.REACT_APP_MIN_WITHDRAWL_AMOUNT ? parseInt(process.env.REACT_APP_MIN_WITHDRAWL_AMOUNT) : 10,
    FEEDBACK_FORM_DISPLAY_DELAY: process.env.REACT_APP_FEEDBACK_FORM_DISPLAY_DELAY ? parseInt(process.env.REACT_APP_FEEDBACK_FORM_DISPLAY_DELAY) : 10,//in secs
    FEEDBACK_FORM_SRC: process.env.REACT_APP_FEEDBACK_FORM_SRC ? process.env.REACT_APP_FEEDBACK_FORM_SRC : 'https://docs.google.com/forms/d/e/1FAIpQLScCVk978P2EUUi0bki6kzK6fcCMPZc6pu0_JStQ_3XuPnyqZw/viewform?embedded=true&entry.1789878114=%email%',
};
